import { useRef, useState, useEffect, useCallback } from "react";
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import clsx from "clsx";

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from "../../../components/headerBtn/headerBtn";

import CurrentEmployees from '../../../pages/employees/currentEmployees/currentEmployees';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const СurrentEmployeesSection = () => {
	const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

	const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
	const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

	const buttonsContainerRef = useRef<HTMLDivElement>(null);

	const sidebarWidth = isOpenSidebar ? 190 : 44;
	const headerFiltersAndSelectWidth = 525;
	const minEmptyWidthForNewBtn = 300;
	const groupBtnWidth = 70;
	const buttonWidth = 130;

	const availableButtons = [
    {
      component: (
        <HeaderBtn
          content='Настройки'
          purpose='employeesListSettings'
          modalTitle='Настройки'
        />
      )
    },
    {
      component: (
        <HeaderBtn
          content='Новый сотрудник'
          purpose='createEmployee'
          modalTitle='Новый сотрудник'
        />
      )
    },
    {
      component: (
        <HeaderBtn
          content='Выгрузить список'
          purpose='unloadStafftReport'
          modalTitle='Выгрузить список'
          hasIcon='excel'
        />
      ),
    },
    {
      component: (
        <HeaderBtn
          content='Выгрузить измененные'
          purpose='unloadModifiedData'
          modalTitle='Выгрузить список изменения сотрудников'
          hasIcon='excel'
        />
      ),
    },
    {
      component: (
        <HeaderBtn
          content='Загрузка договоров'
          purpose='loadingContracts' 
          modalTitle='Загрузка договоров'
        />
      )
    },
    {
      component: (
        <HeaderBtn
          content='Загрузка почты'
          purpose='loadingMail'
          modalTitle='Загрузка почты'
        />
      )
    },
    {
      component: (
        <HeaderBtn
          content='Массовое увольнение'
          purpose='massLayoff'
          modalTitle='Массовое увольнение'
        />
      ),
    },
    {
      component: (
        <HeaderBtn
          content='Штат компании'
          purpose='companyStaff'
          modalTitle='Штат компании'
        />
      ),
    },
  ];

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

    useEffect(() => {
      if (
        filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
        filteredAvailableButtons.length
      ) {
        setOverflowedBtnsCount(0);
      }
    }, [filteredAvailableButtons, overflowedBtnsCount]);
  
    const handleWindowResize = useCallback(() => {
      const allButtonsWidth =
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length * buttonWidth;
      const windowWidth = window.innerWidth;
      const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
        ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
        : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;
  
      if (isOverflowed) {
        setIsOpenGroupBtn(true);
        setOverflowedBtnsCount((prevValue: number) => {
          if (overflowedBtnsCount === filteredAvailableButtons.length) {
            return prevValue;
          } else {
            return overflowedBtnsCount + 1;
          }
        });
      }
  
      const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
        ? windowWidth - sidebarWidth - allButtonsWidth + groupBtnWidth > minEmptyWidthForNewBtn
        : allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
      if (isEnoughtSpace) {
        setOverflowedBtnsCount((prevValue: number) => {
          if (prevValue <= 1) {
            setIsOpenGroupBtn(false);
            return 0;
          } else return prevValue - 1;
        });
      }
    }, [filteredAvailableButtons, overflowedBtnsCount, sidebarWidth]);
  
    useEffect(() => {
      handleWindowResize();
      window.addEventListener('resize', handleWindowResize);
  
      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, [handleWindowResize]);

    return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				availableButtons={displayedAvailableBtns}
				pageName='reports'
				section='Сотрудники'
			>
				<div className='content__main'>
					<div className={clsx(
						isOpenSidebar &&
						"btns_active",
						!isOpenSidebar && "btns_close",
						'btns'
					)}>
						<Link to={`/employees`} className='tab'>
							<div className='buttons__btn  --active'>Действующие</div>
						</Link>
						{(
								<Link
                to={'/employees/fired'}
                className='tab'
								>
									<div className='buttons__btn'>Уволенные</div>
								</Link>
							)}
						{<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Документы</div>
						</Link>}
					</div>
					<CurrentEmployees />
				</div>
			</SectionContent>
		</div>
	);
};

export default СurrentEmployeesSection;